export const notificationConfig = {
  nzDuration: 3500,
  nzPlacement: 'bottomRight',
  nzPauseOnHover: true,
  nzMaxStack: 2,
};
